/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCityRequestViewModel } from "../types/CreateCityRequestViewModel.ts";

export const createCityRequestViewModelSchema = z.object({
  code: z.string().nullish(),
  name: z.string().nullish(),
  stateId: z.optional(z.number().int()),
  population: z.optional(z.number().int()),
}) as unknown as ToZod<CreateCityRequestViewModel>;
